/** Cognito's typed name is the contract; arbitrary error messages are not. */
export const isAuthErrorNamed = (cause: unknown, ...names: string[]): boolean =>
  typeof cause === 'object' &&
  cause !== null &&
  'name' in cause &&
  typeof cause.name === 'string' &&
  names.includes(cause.name)
